import React from 'react';
import PropTypes from 'prop-types';

let inputElement = null;
const GenericFileUpload = ({
  id,
  name,
  btnDisabled,
  btnStyle,
  handleUpload,
  title,
  trackerFn,
  accept,
}) => {
  const handleChange = e => {
    e.preventDefault();
    const reader = new FileReader();
    const fileName = e.target.files[0] ? e.target.files[0].name : '';
    reader.onload = event => {
      const contents = event.target.result;
      handleUpload(contents, fileName);
    };
    if (e.target.files[0]) {
      reader.readAsText(e.target.files[0]);
    }
    inputElement.value = null;
  };

  return (
    <label htmlFor={id} className="display-block" title={title}>
      <span className={btnStyle} disabled={btnDisabled}>
        {name}
      </span>
      <input
        type="file"
        id={id}
        ref={node => (inputElement = node)}
        className="hidden"
        onChange={handleChange}
        disabled={btnDisabled}
        onClick={trackerFn}
        accept={accept}
      />
    </label>
  );
};

GenericFileUpload.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  btnDisabled: PropTypes.bool,
  btnStyle: PropTypes.string,
  handleUpload: PropTypes.func,
  trackerFn: PropTypes.func,
  accept: PropTypes.string,
};

GenericFileUpload.defaultProps = {
  btnStyle: 'button',
  title: '',
  name: '',
  btnDisabled: false,
};

export default GenericFileUpload;
